import { render, staticRenderFns } from "./ComboTipoEnvioNotificacao.vue?vue&type=template&id=7e0bae30"
import script from "./ComboTipoEnvioNotificacao.vue?vue&type=script&lang=ts"
export * from "./ComboTipoEnvioNotificacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports